import "./BannerSlider.css";
import { useEffect, useState } from "react";
import { getActiveBanners } from "../../../services/customerService";
import getImageUrl from "../../../utils/imageUrl";
const defaultOffers = [
  {
    id: 1,
    title: "50% OFF",
    subtitle: "On Your First Order",
    button: "Order Now",
    image: "/images/banners/banner1.png",
    color: "#A0001C",
    redirectType: "Home",
    redirectValue: "",
  },
  {
    id: 2,
    title: "Free Delivery",
    subtitle: "Above ₹299",
    button: "Explore",
    image: "/images/banners/banner2.png",
    color: "#FF6B35",
    redirectType: "Home",
    redirectValue: "",
  },
  {
    id: 3,
    title: "Fresh Home Food",
    subtitle: "Healthy • Hygienic • Delicious",
    button: "Browse",
    image: "/images/banners/banner3.png",
    color: "#5E35B1",
    redirectType: "Home",
    redirectValue: "",
  },
];

function BannerSlider() {
  const [offers, setOffers] = useState([]);
  const [current, setCurrent] = useState(0);

  const bannerList = offers.length ? offers : defaultOffers;

  // ==========================
  // Load banners
  // ==========================

  useEffect(() => {
    fetchBanners();
  }, []);

  const fetchBanners = async () => {
    try {
      const res = await getActiveBanners();

      console.log("Banner Response:", res);

      if (res.success) {
        const formatted = res.banners.map((item) => ({
          id: item._id,
          title: item.title,
          subtitle: item.description,
          button: item.buttonText || "Order Now",
          image: getImageUrl(item.bannerImage),
          color: item.backgroundColor || "#A0001C",
          redirectType: item.redirectType,
          redirectValue: item.redirectValue,
        }));

        setOffers(formatted);
      }
    } catch (err) {
      console.error("Banner loading failed:", err);
    }
  };

  // ==========================
  // Auto Slider
  // ==========================

  useEffect(() => {
    if (!bannerList.length) return;

    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % bannerList.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [bannerList]);

  if (!bannerList.length) return null;

  const banner = bannerList[current];

  // ==========================
  // Button Action
  // ==========================

  const handleBannerClick = () => {
    console.log(
      "Redirect Type:",
      banner.redirectType,
      "Value:",
      banner.redirectValue
    );

    // Navigation logic will come later
  };

  return (
    <section className="banner-slider">

      <div
        className="banner-card"
        style={{
          backgroundColor: banner.color,
        }}
      >

        {/* Background Image */}

       {banner.image && (
  <img
    src={banner.image}
    alt={banner.title}
    className="banner-background"
    onError={(e) => {
      e.currentTarget.src = "/images/banners/banner1.png";
    }}
  />
)}
        {/* Dark Overlay */}

        <div className="banner-overlay"></div>

        {/* Banner Content */}

        <div className="banner-content">

          <span className="banner-tag">
            🔥 Today's Special
          </span>

          <h2>{banner.title}</h2>

          <p>{banner.subtitle}</p>

          <button
            onClick={handleBannerClick}
            className="banner-btn"
          >
            {banner.button}
          </button>

        </div>

      </div>

      {/* Slider Dots */}

      <div className="banner-dots">

        {bannerList.map((item, index) => (

          <span
            key={item.id}
            className={
              current === index
                ? "active"
                : ""
            }
            onClick={() => setCurrent(index)}
          />

        ))}

      </div>

    </section>
  );
}

export default BannerSlider;